import React, { useEffect, useRef, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { FileUploader } from "react-drag-drop-files";
import Button from "@mui/material/Button";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { addProduct } from "../../../apis/product";
import Spinner from "../../../components/spinner";
import MuiAlert from "@mui/material/Alert";
import Modal from "@mui/material/Modal";
import { GrAdd } from "react-icons/gr";
import Configurations from "../../../components/section/configurations";
import { useNavigate } from "react-router-dom";
import ProductDetails from "../../../components/elements/ProductDetails/ProductDetails";
import useRead from "../../../hooks/useRead";
import useReadUpdated from "../../../hooks/updated/useRead";
import useCreate from "../../../hooks/useCreate";
import useUploadMedia from "../../../hooks/file/useUploadMedia";
import Loader from "../../../components/loader";
import toast from "react-hot-toast";
import deBounce from "../../../hooks/useDebounce";
import Editor from "../../../components/elements/Editor";
import { ReactSortable } from "react-sortablejs";
import AsyncSelect from "../../../components/elements/inputs/AsyncSelect";
import CategorySelectModal from "./CategorySelectModal";
import CategorySelectButton from "./CategorySelectButton";
import Badge from "@mui/material/Badge";
import useGet from "../../../hooks/useGet";
import IngredientsSelectModal from "./IngredientsSelectModal";
import IngredientsSelectButton from "./IngredientsSelectButton";
import ConcernSelectModal from "./ConcernSelectModal";
import ConcernSelectButton from "./ConcernSelectButton";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { onNumberKeydown, onNumberFieldPaste } from "../../../utilities";

const fileTypes = ["JPG", "PNG", "JPEG"];
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AddProduct() {
  const initialData = {
    pageNo: 0,
    limit: 50,
    searchQuery: "",
  };
  const navigate = useNavigate();
  const productImageUpload = useRef(null);
  const initialState = {
    product_name: "",
    brand_id: "",
    slug: "",
    title: "",
    subtitle: "",
    description: "",
    short_description: "",
    mrp_price: "",
    selling_price: "",
    business_selling_price: "",
    discount: "",
    quantity: "",
    item_code: "",
    hsn_code: "",
    article_no: "",
    sku_code: "",
    en: "",
    stock_status: "",
    // category_id: "",
    category: [],
    ingredients: [], // Add ingredients field
    concerns: [], // Add concerns field
    tax_id: "",
    is_nonveg: "",
    gender: "", // Add gender field
    product_details: [],
    meta_title: "",
    meta_description: "",
    seo: {
      url_key: "",
      meta_title: "",
      meta_keywords: "",
      meta_description: "",
    },
    thumbnail: {
      image_id: "",
      image_path: "",
      image_alt: "",
    },
    additional_product_image: [],
    charge_incl: false,
    content_type: "",
    weight: "grams",
    best_selling: false,
    new_arrivals: false,
    up_value: "",
    up_total: "",
    up_unit: "",
  };
  const fileInputRef = useRef(null);
  const [imagePreview, setImagePreview] = useState(null);
  //   const [multiImagePreview, setMultiImagePreview] = useState(null);
  const [productData, setProductData] = useState(initialState);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [slugCheck, setSlugCheck] = useState();
  const [slug, setSlug] = useState();
  const [categoryModalOpen, setCategoryModalOpen] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);

  // New state for ingredients and concerns
  const [ingredientsModalOpen, setIngredientsModalOpen] = useState(false);
  const [selectedIngredients, setSelectedIngredients] = useState([]);
  const [concernModalOpen, setConcernModalOpen] = useState(false);
  const [selectedConcerns, setSelectedConcerns] = useState([]);

  const [brandOptions, setBrandOptions] = useState([]);
  const [brandHasMore, setBrandHasMore] = useState(true);
  const [brandPageNo, setBrandPageNo] = useState(0);
  const [brandSearchQuery, setBrandSearchQuery] = useState("");
  // const [isBrandLoading, setIsBrandLoading] = useState(false);

  function sanitizetext(intext) {
    const noSpecialChars = intext.replace(/[^a-zA-Z0-9\-]/g, "");
    // urlcheck(noSpecialChars)
    return noSpecialChars;
  }
  const callapi = (e, data) => {
    checkSlugData.mutate(data);
  };

  const handleAddFromData = (e, file, isFileObject, name) => {
    let data;
    e.preventDefault?.();
    if (e.target.name == "product_name") {
      let newval = e.target.value;
      newval = newval.replace(/\s+/g, "-").toLowerCase();
      let sanval = sanitizetext(newval);
      let data = {
        ...productData,
        slug: sanval,
        product_name: e.target.value,
      };
      setProductData(data);
      setSlug({ ...data });
      let senddata = {
        slug: sanval,
      };
      deBounce((e) => callapi(e, senddata), senddata);
      return;
    } else {
      if (file) {
        if (isFileObject) {
          data = {
            ...productData,
            [name]: e,
          };
        } else {
          let fileObject = e.target.files[0];
          data = {
            ...productData,
            [e.target.name]: fileObject,
          };
        }
      } else {
        if (e.target.name === "seo") {
          let value = e.target.value;
          let tempName = e.target.attributes["data-name"].value;
          data = {
            ...productData,
            seo: {
              ...productData?.seo,
              [tempName]: value,
            },
          };
        } else {
          let value = e.target.value;
          data = {
            ...productData,
            [e.target.name]: value,
          };
        }
      }
    }
    setProductData(data);
  };

  const slugInput = (e) => {
    let val = e.target.value;
    val = val.replace(/\s+/g, "-").toLowerCase();
    let sanval = sanitizetext(val);
    let data = {
      ...productData,
      slug: sanval,
    };
    // setSlug(sanval)
    setProductData({ ...data });
    setSlug({ ...data });
    let senddata = {
      slug: sanval,
    };
    deBounce((e) => callapi(e, senddata), senddata);
  };

  const closeErrorMessage = () => {
    setIsError(false);
  };
  const { setDataToServer } = useCreate({
    url: "product/create",
    refreshUrl: "product/list",
    onSuccess: () => {
      toast.success("Product Added Successfully", {
        position: "top-right",
        duration: 3000,
      });
    },
  });
  const { setDataToServer: checkSlugData } = useCreate({
    refreshUrl: "",
    url: "product/check_slug",
    onSuccess: (data) => {
      setSlugCheck(false);
      // setIsSuccess(true)
    },
    onError: (err) => {
      setSlugCheck(true);
      // setIsError(true)
    },
  });

  const handleProductSubmit = (e) => {
    e.preventDefault();
    setDataToServer.mutate(productData);
  };
  const handleCloseAndReset = () => {
    setProductData(initialState);
    closeErrorMessage();
  };
  const handleuploadAgain = () => {
    let data = {
      ...productData,
      product_thumbnail_preview: "",
      product_thumbnail: "",
    };
    setProductData(data);
  };
  useEffect(() => {
    isError && setTimeout(() => setIsError(false), [4000]);
  }, [isError]);
  //   const [uploadScreen, setUploadScreen] = useState(null); // For upload context
  // const { data: categoryList, isLoading: isCategoryLoading } = useRead({
  //   method: "GET",
  //   url: "category/list",
  //   initialData,
  // });

  // Fetch tax list from API
  const { data: taxList } = useRead({
    method: "GET",
    url: "tax/list",
    initialData,
  });

  const [openUploadImagesModal, setOpenUploadImagesModal] = useState(false);
  const handleOpenUploadModal = () => {
    setOpenUploadImagesModal(true);
  };
  const handleCloseUploadImageModal = () => {
    setOpenUploadImagesModal(false);
  };
  const handleClickOpenFileDialog = () => {
    productImageUpload.current.click();
  };
  const handleUploadImages = (e) => {
    let previewImag = [];
    for (let i = 0; i < e.target.files.length; i++) {
      previewImag.push(URL.createObjectURL(e.target.files[i]));
    }
    let data = {
      ...productData,
      images_of_product: [...productData.images_of_product, ...e.target.files],
      images_of_product_preview: [
        ...productData.images_of_product_preview,
        ...previewImag,
      ],
    };
    setProductData(data);
  };

  const [openConfigModal, setOpenConfigModal] = useState(false);
  const handleOpenConfigurationModal = () => {
    setOpenConfigModal(true);
  };
  //   let uploadScreen;
  // const { upload } = useUploadMedia({
  //     url: "uploadImage",
  //     refreshUrl: "",
  //     onSuccess: (res) => {
  //         let productCopy = { ...productData };
  //         if (uploadScreen === "thumbnail") {
  //             productCopy["thumbnail"] = { image_alt: "", ...res.data[0] };
  //         } else {
  //             // productCopy['additional_product_image'] = res.data.map((addImg) => {
  //             //     return { image_alt: '', ...addImg }
  //             // })
  //             productCopy["additional_product_image"] = [
  //                 ...productCopy["additional_product_image"],
  //                 ...res?.data.map((addImg) => {
  //                     return { image_alt: "", ...addImg };
  //                 }),
  //             ];
  //         }
  //         setProductData(productCopy);
  //         toast.success("Product Added Successfully", {
  //             position: "top-right",
  //             duration: 3000,
  //         });
  //     },
  // });
  const handleOpenFileUploadDialog = () => {
    fileInputRef.current.click();
  };
  const { upload } = useUploadMedia({
    url: "upload/image",
    onSuccess: (res) => {
      const { image_url, image_id } = res?.data;

      let formDataCopy = productData;
      //   formDataCopy.thumbnail = {};
      formDataCopy["thumbnail"].image_id = image_id;

      setImagePreview(image_url);
      setProductData({ ...productData });
      const apiMessage = res?.message;
      toast.success(apiMessage || "Image Uploaded Successfully", {
        position: "top-right",
        duration: 3000,
      });
    },
    onError: (err) => {
      const apiMessage = err?.response?.data?.message;
      toast.error(apiMessage || "Error Uploading Image", {
        position: "top-right",
        duration: 3000,
      });
    },
  });

  const setMultiImagePreview = (val) => {
    const newValue = { ...productData };
    newValue.images_of_product_preview = val;
    setProductData(newValue);
  };

  useEffect(() => {
    if (!productData.product_thumbnail) return;
    const objectUrl = URL.createObjectURL(productData.product_thumbnail);
    let data = {
      ...productData,
      product_thumbnail_preview: objectUrl,
    };
    setProductData(data);
    return () => URL.revokeObjectURL(objectUrl);
  }, [productData.product_thumbnail]);
  let uploadScreen;
  const { upload: ImagesUpload } = useUploadMedia({
    url: "upload/image",
    refreshUrl: "",
    onSuccess: (res) => {
      let copyProduct = { ...productData };
      if (uploadScreen === "product_thumbnail") {
        copyProduct["product_thumbnail"] = { image_alt: "", ...res.data[0] };
      } else {
        let copyAdditionalProductImage =
          copyProduct["additional_product_image"];
        copyAdditionalProductImage = [...copyAdditionalProductImage, res?.data];
        copyProduct["additional_product_image"] = copyAdditionalProductImage;
      }
      setProductData(copyProduct);
      const apiMessage = res?.message;
      toast.success(apiMessage || "Image Uploaded Successfully", {
        position: "top-right",
        duration: 3000,
      });
    },
    onError: (err) => {
      const apiMessage = err?.response?.data?.message;
      toast.error(apiMessage || "Error Uploading Image", {
        position: "top-right",
        duration: 3000,
      });
    },
  });

  //   let uploadScreen;
  const handleUploadFile = (e) => {
    let thumbnail = e.target?.files[0];

    let data = {
      screen: "products",
      thumbnail: [thumbnail],
    };
    upload.mutate(data);
  };
  //   let uploadScreen;
  //   const { upload } = useUploadMedia({
  //     url: "uploadImage",
  //     refreshUrl: "",
  //     onSuccess: (res) => {
  //       let copyProduct = { ...productData };
  //       if (uploadScreen === "product_thumbnail") {
  //         copyProduct["product_thumbnail"] = { image_alt: "", ...res.data[0] };
  //       } else {
  //         let copyAdditionalProductImage =
  //           copyProduct["additional_product_image"];
  //         copyAdditionalProductImage = [
  //           ...copyProduct["additional_product_image"],
  //           ...res?.data?.map((addImg) => {
  //             return { image_alt: "", ...addImg };
  //           }),
  //         ];
  //         copyProduct["additional_product_image"] = copyAdditionalProductImage;
  //       }
  //       setProductData(copyProduct);
  //       toast.success("Image Uploaded Successfully", {
  //         position: "top-right",
  //         duration: 3000,
  //       });
  //     },
  //   });

  //   const handleUploadFile = (e, screen) => {
  //     uploadScreen = screen;
  //     let data = {
  //       screen: "products",
  //       thumbnail: [...e],
  //     };
  //     upload.mutate(data);
  //   };

  const handleImagesUploadFile = (e, screen) => {
    // let thumbnail = files[0];
    uploadScreen = screen;
    const data = {
      screen: "products",
      thumbnail: [...e],
    };
    // setUploadScreen(uploadScreen); // Set the context for onSuccess callback

    ImagesUpload.mutate(data);
  };
  const handleRemoveSelectedProductImage = (e, id) => {
    e.stopPropagation();
    let predData = productData;
    predData.additional_product_image.splice(id, 1);
    setProductData({ ...productData });
  };

  const handleImageAltTextChange = (e, index) => {
    const value = e.target.value;
    const temp = productData?.additional_product_image;
    temp[index].image_alt = value;
    setProductData({
      ...productData,
      additional_product_image: temp,
    });
  };
  const handleRemoveProductImage = (id) => {
    let productCopy = { ...productData };
    productCopy.additional_product_image =
      productCopy.additional_product_image.filter((x) => x.image_id !== id);
    setProductData(productCopy);
  };

  const handleChangeEditor = (e, value) => {
    let data = {
      ...productData,
      description: value,
    };
    setProductData(data);
  };

  const handleCheckBox = (e) => {
    let data = {
      ...productData,
      [e.target.name]: e.target.checked,
    };
    setProductData(data);
  };

  // Handle open/close modal for categories
  const handleOpenCategoryModal = () => setCategoryModalOpen(true);
  const handleCloseCategoryModal = () => setCategoryModalOpen(false);

  // Handle open/close modal for ingredients
  const handleOpenIngredientsModal = () => setIngredientsModalOpen(true);
  const handleCloseIngredientsModal = () => setIngredientsModalOpen(false);

  // Handle open/close modal for concerns
  const handleOpenConcernModal = () => setConcernModalOpen(true);
  const handleCloseConcernModal = () => setConcernModalOpen(false);

  // Handle save from modals
  const handleSaveCategories = (categories) => {
    setSelectedCategories(categories);
    // Save as array of {category_id: ...}
    setProductData({
      ...productData,
      category: categories.map((cat) => ({ category_id: cat.id })),
    });
    setCategoryModalOpen(false);
  };

  // Add a handler for image_alt input to update both fields
  const handleImageAltInput = (e) => {
    const value = e.target.value;
    setProductData((prev) => ({
      ...prev,
      image_alt: value,
      thumbnail: {
        ...prev.thumbnail,
        image_alt: value,
      },
    }));
  };
  // Handle save ingredients from modal
  const handleSaveIngredients = (ingredients) => {
    setSelectedIngredients(ingredients);
    // Save as array of {ingredient_id: ...}
    setProductData({
      ...productData,
      ingredients: ingredients.map((item) => ({
        ingredient_id: item.ingredient_id,
        category_name: item.name,
      })),
    });
    setIngredientsModalOpen(false);
  };

  // Handle save concerns from modal
  const handleSaveConcerns = (concerns) => {
    setSelectedConcerns(concerns);
    // Save as array of {concern_id: ...}
    setProductData({
      ...productData,
      concerns: concerns.map((item) => ({
        concern_id: item.concern_id,
        category_name: item.name,
      })),
    });
    setConcernModalOpen(false);
  };

  // Replace useRead with useGet for brand list
  const {
    data: brandData,
    setParamsObject: setBrandParams,
    data: brandQuery,
  } = useGet({
    url: "brand/list",
    initialParams: {
      pageNo: 0,
      limit: 10,
      searchQuery: "",
    },
    onSuccess: (response) => {
      const formattedOptions =
        response?.data?.map((brand) => ({
          value: brand.brand_id,
          label: brand.name,
        })) || [];

      if (brandPageNo === 0) {
        setBrandOptions(formattedOptions);
      } else {
        setBrandOptions((prev) => [...prev, ...formattedOptions]);
      }

      setBrandHasMore(
        formattedOptions.length > 0 &&
          response?.totalCount > brandOptions.length
      );
    },
    onError: (err) => {
      console.error("Brand fetch error:", err);
    },
  });

  // Function to fetch brands with pagination and search
  const fetchBrands = (query = "", reset = false) => {
    const pageToFetch = reset ? 0 : brandPageNo;

    if (reset) {
      setBrandPageNo(0);
      setBrandOptions([]);
    }

    setBrandParams({
      pageNo: pageToFetch,
      limit: 10,
      searchQuery: query,
    });

    if (!reset) {
      setBrandPageNo((prev) => prev + 1);
    }

    setBrandSearchQuery(query);
  };

  // Handle brand selection
  const handleBrandSelect = (brandId) => {
    let data = {
      ...productData,
      brand_id: brandId,
    };
    setProductData(data);
  };

  return (
    <>
      {upload.isLoading && (
        <div className="fixed w-full h-full bg-[#ffffff70] top-0 left-0 z-50">
          <div className="flex w-full items-center justify-center h-full">
            <Loader className={"text-black !w-12 !h-12"} />
          </div>
        </div>
      )}
      <div className="container_xxl bg-[#eceff1] px-4">
        <div className="flex items-center space-x-4 headingBorder__b sticky top-0 z-10">
          <div>
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBackIcon />
            </IconButton>
          </div>
          <div>
            <h1 className="heading">Add Product</h1>
          </div>
        </div>
        <div className="form-body py-8">
          <form className="" autoComplete="off" onSubmit={handleProductSubmit}>
            <div className="grid grid-cols-1 gap-4">
              <div className="mb-3 flex items-center justify-between border-b border-gray-400">
                <h1 className="font-semibold text-2xl pb-3">Product Listing</h1>
              </div>
              <div>
                <label htmlFor="Product Name" className="label">
                  Product Name <small className="text-red-700">*</small>
                </label>
                <input
                  required
                  type="text"
                  placeholder="Product Name"
                  name="product_name"
                  className="input"
                  value={productData?.product_name}
                  onChange={(e) => handleAddFromData(e)}
                />
              </div>
              <div>
                <label htmlFor="Slug" className="label">
                  Slug <small className="text-red-700">*</small>
                </label>
                <input
                  required
                  type="text"
                  placeholder="Slug"
                  name="slug"
                  className="input"
                  value={productData?.slug}
                  onChange={slugInput}
                />
                {slugCheck ? (
                  <p
                    class=" text-red-600 text-base mb-6 mt-6 font-semibold"
                    id="slugerror"
                  >
                    Slug already exist
                  </p>
                ) : (
                  ""
                )}
              </div>
              <div className="flex flex-col md:flex-row w-full justify-center items-center gap-5">
                {/* <div className="w-full">
                  <label htmlFor="Product Short Name" className="label">
                    Product Short Name
                  </label>
                  <input
                    type="text"
                    placeholder="Product Short Name"
                    name="short_name"
                    className="input"
                    value={productData?.short_name}
                    onChange={handleAddFromData}
                  />
                </div> */}
                <div className="w-full">
                  <label className="label">
                    Brand <small className="text-red-700">*</small>
                  </label>
                  <AsyncSelect
                    // label="Select Brand"
                    options={brandOptions}
                    hasMore={brandHasMore}
                    fetchNext={fetchBrands}
                    isLoading={brandQuery?.isFetching}
                    value={productData?.brand_id}
                    onChange={handleBrandSelect}
                  />
                </div>
              </div>
              <div className="flex items-center gap-8 mt-2 mb-2">
                <label className="flex items-center cursor-pointer gap-2">
                  {productData.best_selling ? (
                    <CheckBoxIcon color="primary" />
                  ) : (
                    <CheckBoxOutlineBlankIcon color="action" />
                  )}
                  <input
                    type="checkbox"
                    name="best_selling"
                    checked={productData.best_selling}
                    onChange={handleCheckBox}
                    className="hidden"
                  />
                  <span>Best Selling</span>
                </label>
                <label className="flex items-center cursor-pointer gap-2">
                  {productData.new_arrivals ? (
                    <CheckBoxIcon color="primary" />
                  ) : (
                    <CheckBoxOutlineBlankIcon color="action" />
                  )}
                  <input
                    type="checkbox"
                    name="new_arrivals"
                    checked={productData.new_arrivals}
                    onChange={handleCheckBox}
                    className="hidden"
                  />
                  <span>New Arrival</span>
                </label>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-4">
              <div className="mb-3 flex items-center justify-between border-b border-gray-400 mt-10">
                <h1 className="font-semibold text-2xl pb-3">Product Info</h1>
              </div>
              {/* <div>
                                <label htmlFor="Product Name" className='label'>Product Name <small className="text-red-700">*</small></label>
                                <input required type="text" placeholder='Product Name' name='product_name' className='input' value={productData.product_name} onChange={handleAddFromData} />
                            </div> */}
              <div>
                <label htmlFor="Product Title" className="label">
                  Title
                  {/* <small className="text-red-700">*</small> */}
                </label>
                <input
                  type="text"
                  placeholder="Product title"
                  name="title"
                  className="input"
                  value={productData?.title}
                  onChange={handleAddFromData}
                />
              </div>
              {/* <div>
                <label htmlFor="Product Subtitle" className="label">
                  Subtitle
                </label>
                <input
                  type="text"
                  placeholder="Product Name"
                  name="subtitle"
                  className="input"
                  value={productData?.subtitle}
                  onChange={handleAddFromData}
                />
              </div> */}
              <section className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* --- Item Code field --- */}
                <div>
                  <label htmlFor="item_code" className="label">
                    Item Code
                  </label>
                  <input
                    type="text"
                    placeholder="Item code"
                    name="item_code"
                    className="input"
                    value={productData?.item_code}
                    onChange={handleAddFromData}
                  />
                </div>
                {/* --- HSN Code field --- */}
                <div>
                  <label htmlFor="hsn_code" className="label">
                    HSN Code
                  </label>
                  <input
                    type="text"
                    placeholder="HSN code"
                    name="hsn_code"
                    className="input"
                    value={productData?.hsn_code}
                    onChange={handleAddFromData}
                  />
                </div>
                {/* --- Article No. field --- */}
                <div>
                  <label htmlFor="article_no" className="label">
                    Article No.
                  </label>
                  <input
                    type="text"
                    placeholder="Article no."
                    name="article_no"
                    className="input"
                    value={productData?.article_no}
                    onChange={handleAddFromData}
                  />
                </div>
                {/* --- SKU field --- */}
                <div>
                  <label htmlFor="SKU" className="label">
                    SKU
                  </label>
                  <input
                    type="text"
                    placeholder="SKU"
                    name="sku_code"
                    className="input"
                    value={productData?.sku_code}
                    onChange={handleAddFromData}
                  />
                </div>
              </section>
              {/* --- EN field --- */}
              {/* <div>
                <label htmlFor="EN" className="label">
                  EN
                </label>
                <input
                  type="text"
                  placeholder="EN"
                  name="en"
                  className="input"
                  value={productData?.en}
                  onChange={handleAddFromData}
                />
              </div> */}
              <div>
                <label htmlFor="Description" className="label">
                  Description <small className="text-red-700">*</small>
                </label>
                <Editor
                  value={productData?.description}
                  onChange={handleChangeEditor}
                />
                {/* <textarea name="description" className=' min-h-[10rem] input' value={productData?.description} onChange={handleAddFromData}></textarea> */}
              </div>
              {/* <div>
                <label htmlFor="Product Short description" className="label">
                  Short Description
                </label>
                <textarea
                  name="short_description"
                  className=" min-h-[10rem] input"
                  value={productData?.short_description}
                  onChange={handleAddFromData}
                ></textarea>
              </div> */}
            </div>
            <div>
              <div className="my-7 flex items-center justify-between border-b border-gray-400">
                <h1 className="font-semibold text-2xl pb-3">Product Details</h1>
              </div>
              <div className=" space-y-7">
                <div className={`grid grid-cols-1 md:grid-cols-3 gap-4`}>
                  {/* <div>
        <label className="label">
          Price <small className="text-red-700">*</small>
        </label>
        <input
          required
          type="text"
          placeholder="Price"
          name="mrp_price"
          className="input"
          value={productData?.mrp_price}
          onChange={handleAddFromData}
        />
      </div> */}
                  <div>
        <label className="label">
          Stock Quantity <small className="text-red-700">*</small>
        </label>
        <input
          required
          type="number"
          min="0"
          step="1"
          placeholder="Stock quantity"
          name="quantity"
          className="input"
          value={productData?.quantity}
          onChange={handleAddFromData}
        />
      </div>
                  {/* <div>
        <label className="label">
          SKU <small className="text-red-700">*</small>
        </label>
        <input
          required
          type="text"
          placeholder="SKU"
          name="sku"
          className="input"
          value={productData?.sku}
          onChange={handleAddFromData}
        />
      </div> */}

                  <div>
                    <label className="label">
                      MRP Price <small className="text-red-700">*</small>
                    </label>
                    <input
                      required
                      type="number"
                      placeholder="MRP Price"
                      name="mrp_price"
                      className="input"
                      value={productData?.mrp_price}
                      onChange={handleAddFromData}
                    />
                  </div>
                  <div>
                    <label className="label">
                      Selling Price <small className="text-red-700">*</small>
                    </label>
                    <input
                      required
                      type="number"
                      placeholder="Selling Price"
                      name="selling_price"
                      className="input"
                      value={productData?.selling_price}
                      onChange={handleAddFromData}
                    />
                  </div>
                  <div>
                    <label className="label">
                      Business Selling Price{" "}
                      <small className="text-red-700">*</small>
                    </label>
                    <input
                      required
                      type="number"
                      placeholder="Business Selling Price"
                      name="business_selling_price"
                      className="input"
                      value={productData?.business_selling_price}
                      onChange={handleAddFromData}
                    />
                  </div>
                  <div>
                    <label className="label">
                      Category
                      {/* <small className="text-red-700">*</small> */}
                    </label>
                    <CategorySelectButton
                      count={selectedCategories.length}
                      onClick={handleOpenCategoryModal}
                    />
                    <CategorySelectModal
                      open={categoryModalOpen}
                      onClose={handleCloseCategoryModal}
                      selected={selectedCategories}
                      onSave={handleSaveCategories}
                    />
                  </div>
                  <div>
                    <label className="label">Ingredients</label>
                    <IngredientsSelectButton
                      count={selectedIngredients.length}
                      onClick={handleOpenIngredientsModal}
                    />
                    <IngredientsSelectModal
                      open={ingredientsModalOpen}
                      onClose={handleCloseIngredientsModal}
                      selected={selectedIngredients}
                      onSave={handleSaveIngredients}
                    />
                  </div>
                  <div>
                    <label className="label">Concerns</label>
                    <ConcernSelectButton
                      count={selectedConcerns.length}
                      onClick={handleOpenConcernModal}
                    />
                    <ConcernSelectModal
                      open={concernModalOpen}
                      onClose={handleCloseConcernModal}
                      selected={selectedConcerns}
                      onSave={handleSaveConcerns}
                    />
                  </div>
                  <div>
                    <label className="label">Unit Price Value</label>
                    <input
                      type="number"
                      placeholder="Unit Price Value"
                      name="up_value"
                      className="input"
                      value={productData?.up_value}
                      onChange={handleAddFromData}
                      onKeyDown={(e) =>
                        onNumberKeydown(e, { isPositiveNumber: true })
                      }
                      onPaste={(e) =>
                        onNumberFieldPaste(e, { isPositiveNumber: true })
                      }
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                  <div>
                    <label className="label">Unit Price Total</label>
                    <input
                      type="number"
                      placeholder="Unit Price Total"
                      name="up_total"
                      className="input"
                      value={productData?.up_total}
                      onChange={handleAddFromData}
                      onKeyDown={(e) =>
                        onNumberKeydown(e, { isPositiveNumber: true })
                      }
                      onPaste={(e) =>
                        onNumberFieldPaste(e, { isPositiveNumber: true })
                      }
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>
                  <div>
                    <label className="label">Unit</label>
                    <input
                      type="text"
                      placeholder="Unit (e.g., ml, gm, oz)"
                      name="up_unit"
                      className="input"
                      value={productData?.up_unit}
                      onChange={handleAddFromData}
                    />
                  </div>
                  <div>
                    <label className="label">
                      Gender
                      {/* <small className="text-red-700">*</small> */}
                    </label>
                    <select
                      name="gender"
                      value={productData?.gender}
                      className="input"
                      onChange={handleAddFromData}
                    >
                      <option value="">--Select Gender--</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Unisex">Unisex</option>
                    </select>
                  </div>
                  <div>
                    <label className="label">
                      Tax
                      {/* <small className="text-red-700">*</small> */}
                    </label>
                    <select
                      name="tax_id"
                      value={productData?.tax_id}
                      className="input"
                      onChange={handleAddFromData}
                    >
                      <option value="">--Select Tax--</option>
                      {taxList?.data?.data?.map((tax) => (
                        <option key={tax.id} value={tax.id}>
                          {tax.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {/* <div>
        <label className="label">Selling Price</label>
        <input
          type="text"
          placeholder="Selling Price"
          name="selling_price"
          className="input"
          value={productData?.selling_price}
          onChange={handleAddFromData}
        />
      </div> */}
                  {/* <div>
        <label className="label">Discount</label>
        <input
          type="text"
          placeholder="Discount"
          name="discount"
          className="input"
          value={productData?.discount}
          onChange={handleAddFromData}
        />
      </div> */}
                  {/* <div>
        <label className="label">
          Is Non-Veg ? <small className="text-red-700">*</small>
        </label>
        <select
          name="is_nonveg"
          value={productData?.is_nonveg}
          id=""
          className="input"
          onChange={handleAddFromData}
        >
          <option value="no">No</option>
          <option value="yes">Yes</option>
        </select>
      </div> */}
                  {/* <div>
        <label className="label">
          Product Unit <small className="text-red-700">*</small>
        </label>
        <select
          name="content_type"
          value={productData?.content_type}
          id=""
          className="input"
          onChange={handleAddFromData}
        >
          <option value="">--Select Unit--</option>
          <option value="grams">Grams</option>
          <option value="liters">Liters</option>
          <option value="piece">Piece</option>
        </select>
      </div> */}
                  {/* <div>
        <label className="label">
          Product Weight<small className="text-red-700">*</small>
        </label>
        <input
          type="number"
          placeholder="weight"
          name="weight"
          className="input"
          value={productData?.weight}
          onChange={handleAddFromData}
        />
      </div> */}
                  {/* <div>
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            placeholder="charge_incl"
            id="charge_incl"
            name="charge_incl"
            value={productData?.charge_incl}
            onChange={handleCheckBox}
          />
          <label
            htmlFor="charge_incl"
            className="cursor-pointer select-none"
          >
            Product Delivery Charges Inclusive{" "}
            <small className="text-red-700">*</small>
          </label>
        </div>
      </div> */}
                </div>
              </div>
            </div>
            <div>
              <div className="my-7 flex items-center justify-between border-b border-gray-400">
                <h1 className="font-semibold text-2xl pb-3">
                  Search Engine Optimization
                </h1>
              </div>
              <div>
                <div className="mb-2">
                  <label className="label">Meta Title</label>
                  <input
                    type="text"
                    placeholder="Meta Title"
                    name="meta_title"
                    // data-name="meta_title"
                    className="input"
                    value={productData?.["meta_title"]}
                    onChange={handleAddFromData}
                  />
                </div>
                {/* <div className="mb-2">
                  <label className="label">Meta Keywords</label>
                  <input
                    type="text"
                    placeholder="Meta Keywords"
                    name="seo"
                    data-name="meta_keywords"
                    className="input"
                    value={productData?.seo?.["meta_keywords"]}
                    onChange={handleAddFromData}
                  />
                </div> */}
                <div className="mb-2">
                  <label className="label">Meta Description</label>
                  <input
                    type="text"
                    placeholder="Meta Description"
                    name="meta_description"
                    // data-name="meta_description"
                    className="input"
                    value={productData?.["meta_description"]}
                    onChange={handleAddFromData}
                  />
                </div>
              </div>
            </div>

            <ProductDetails
              productData={productData}
              setProductData={setProductData}
            />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <div className="my-7 flex items-center justify-between border-b border-gray-400">
                  <div className="pb-3">
                    <h1 className="font-semibold text-2xl">
                      Thumbnail of product
                    </h1>
                    <small className="text-red-700">
                      Note:Image to be less than 1mb
                    </small>
                  </div>
                </div>
                {/* <div className=" space-y-4">
                                    }
                                    {!productData.product_thumbnail_preview ? (
                                        <FileUploader
                                            name="product_thumbnail"
                                            types={fileTypes}
                                            handleChange={(e) =>
                                                handleAddFromData(e, true, true, "product_thumbnail")
                                            }
                                            classes="file-uploader"
                                            hoverTitle="Drop here"
                                        />
                                    ) : (
                                        <div className=" border border-dashed border-blue-700 rounded">
                                            <div className=" w-40 mx-auto py-4 text-center space-y-3">
                                                <img
                                                    src={productData.product_thumbnail_preview}
                                                    alt="preview"
                                                />
                                                <Button variant="outlined" onClick={handleuploadAgain}>
                                                    Re-Upload
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </div> */}
                <div className="">
                  <label htmlFor="" className="label">
                    Thumbnail <small className="text-red-700">*</small>
                  </label>
                  {upload.isLoading ? (
                    <>
                      <Spinner />
                    </>
                  ) : (
                    <>
                      {imagePreview && (
                        <img
                          src={imagePreview}
                          alt="blog image"
                          className="object-contain w-48 h-48 my-4"
                        />
                      )}
                    </>
                  )}

                  <div className="mt-5">
                    <Button
                      variant="contained"
                      color="success"
                      className="primaryBtn-contained"
                      onClick={handleOpenFileUploadDialog}
                    >
                      {imagePreview
                        ? "Update Thumbnail Image "
                        : " Add Thumbnail Image"}
                    </Button>
                    <input
                      ref={fileInputRef}
                      type="file"
                      className="hidden"
                      onChange={(e) => handleUploadFile(e)}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div className="my-7 flex items-center justify-between border-b border-gray-400">
                  <div className="pb-3">
                    <h1 className="font-semibold text-2xl">
                      Images of product
                    </h1>
                    <small className="text-red-700">
                      Note:Image to be less than 1mb
                    </small>
                  </div>
                </div>
                <div className="flex items-center justify-center mt-12">
                  <Button
                    onClick={handleOpenUploadModal}
                    variant="contained"
                    color="success"
                    className="primaryBtn-contained"
                  >
                    Add Images
                  </Button>
                </div>
              </div>
              <div>
                <label htmlFor="Image Alt" className="label">
                  Image alt
                </label>
                <input
                  type="text"
                  placeholder="Enter image alt"
                  value={productData.thumbnail.image_alt}
                  onChange={handleImageAltInput}
                  name="image_alt"
                  className="input"
                />
              </div>
            </div>
            {/* <div className='grid grid-cols-2 gap-4'>
                            <div>
                                <div className='my-7 flex items-center justify-between border-b border-gray-400'>
                                    <div className='pb-3'>
                                        <h1 className='font-semibold text-2xl'>Thumbnail of product</h1>
                                        <small className='text-red-700'>Note:Image to be less than 1mb</small>
                                    </div>
                                </div>
                                <div className=' space-y-4'>
                                    <FileUploader name="product_thumbnail" types={fileTypes} handleChange={(e) => handleUploadFile([e], 'thumbnail')} classes="file-uploader" hoverTitle='Drop here' />
                                    {productData?.image_url && <div className=' w-40 mx-auto py-4 text-center space-y-3'>
                                        <img src={productData?.thumbnail?.image_url} alt="preview" />
                                    </div>}
                                    <div className='mb-2'>
                                        <label className='label'>Thumbnail Image Alt Tag</label>
                                        <input type="text" placeholder='Thumbnail Image Alt Tag' value={productData?.thumbnail?.image_alt} onChange={handleChangeThumbImageAlt} name="image_alt" className='input' />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='my-7 flex items-center justify-between border-b border-gray-400'>
                                    <div className='pb-3'>
                                        <h1 className='font-semibold text-2xl'>Images of product</h1>
                                        <small className='text-red-700'>Note:Image to be less than 1mb</small>
                                    </div>
                                </div>
                                <div className='flex items-center justify-center mt-12'>
                                    <Button onClick={handleOpenUploadModal} variant="contained" color='success' className='primaryBtn-contained'>Add Images</Button>
                                </div>
                            </div>
                        </div> */}
            <div className="text-center my-6">
              {setDataToServer.isLoading ? (
                <Spinner />
              ) : (
                <Button
                  type="submit"
                  disabled={slugCheck ? true : false}
                  variant="contained"
                  className="primaryBtn-contained"
                >
                  Save Product
                </Button>
              )}
            </div>
          </form>
        </div>
        {isError && (
          <Alert
            onClose={closeErrorMessage}
            className="mb-4"
            severity="error"
            sx={{ width: "100%" }}
          >
            {setDataToServer?.error?.message}, Please try again later
          </Alert>
        )}
        {isSuccess && (
          <Alert
            onClose={closeErrorMessage}
            className="mb-4"
            severity="success"
            sx={{ width: "100%" }}
          >
            Product Added Succesfully
          </Alert>
        )}
      </div>
      <Modal
        open={openUploadImagesModal}
        onClose={handleCloseUploadImageModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className=" w-full absolute top-4 left-1/2 -translate-x-1/2">
          <div className=" max-w-5xl mx-auto bg-white">
            <div className=" divide-y">
              <div className="head-modal">
                <div className="flex items-center space-x-4 px-6">
                  <div
                    className="w-7 h-7 cursor-pointer"
                    onClick={handleCloseUploadImageModal}
                  >
                    <svg
                      className="w-full h-full"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                      />
                    </svg>
                  </div>
                  <h2 className="heading text-3xl">Upload Product Images</h2>
                </div>
              </div>
              <div className="body-modal py-4 px-6">
                <div className="max-h-[20rem] min-h-[20rem] overflow-auto  relative cursor-pointer">
                  <div className="imagePreview__container relative z-10">
                    <div>
                      <ReactSortable
                        list={productData?.additional_product_image}
                        setList={setMultiImagePreview}
                        className="grid grid-cols-4 gap-4 "
                      >
                        {productData?.additional_product_image?.map(
                          (img, idx) => {
                            const { image_url, image_alt } = img;

                            return (
                              <div key={idx}>
                                <div
                                  className=" w-full overflow-hidden border p-2 relative cursor-default"
                                  key={idx}
                                >
                                  <div className="w-6 h-6 cursor-pointer float-right">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      onClick={(e) =>
                                        handleRemoveSelectedProductImage(e, idx)
                                      }
                                      viewBox="0 0 24 24"
                                      strokeWidth="1.5"
                                      stroke="currentColor"
                                      className="w-full h-full"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                      />
                                    </svg>
                                  </div>
                                  <img
                                    src={image_url}
                                    alt="img"
                                    className="w-full h-40 object-contain"
                                  />
                                  <div className="my-2">
                                    <label className="label">
                                      Product {idx + 1} Alt Tag
                                    </label>
                                    <input
                                      type="text"
                                      value={image_alt}
                                      placeholder={`Product ${idx + 1} Alt Tag`}
                                      onChange={(e) =>
                                        handleImageAltTextChange(e, idx)
                                      }
                                      name="image_alt"
                                      className="input"
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        )}
                        <div
                          onClick={handleClickOpenFileDialog}
                          className="w-full h-48 cursor-pointer select-none border-2 rounded-md border-dashed border-gray-400 flex flex-col items-center justify-center hover:shadow-lg"
                        >
                          <GrAdd className=" w-16 h-16 text-gray-400" />
                          <small>Add Product Image</small>
                        </div>
                      </ReactSortable>
                    </div>
                  </div>
                  <input
                    type="file"
                    className="hidden"
                    ref={productImageUpload}
                    onChange={(e) =>
                      handleImagesUploadFile(
                        e.target.files,
                        "additional_product_image"
                      )
                    }
                    multiple
                    accept="image/jpeg, image/png, image/jpg, image/webp"
                  />
                </div>
              </div>
              <div className="foot-modal py-4 text-center">
                <Button
                  variant="contained"
                  className="primaryBtn-contained px-10"
                  onClick={handleCloseUploadImageModal}
                >
                  Save Images
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default AddProduct;
